import { DateTime } from 'luxon'

export const localizeDate = (dateString: string) => {
  return DateTime.fromISO(dateString, { locale: 'sv-SE' }).toLocaleString()
}
